<template #default>
    <div class="widget-container">
        <!-- <h2 class="content-block">New Order</h2> -->
        <div class="content-block dx-card responsive-paddings">
            <form action="action" @submit.prevent="">
            <DxForm ref="form4" id="form" :form-data="formData" label-mode="floating">
                <DxGroupItem :col-count="2" :caption="$t('registration.version')">
                <DxSimpleItem data-field="Version">
                    <dx-label :text="$t('registration.version')" />
                </DxSimpleItem>
                </DxGroupItem>

                <DxGroupItem :col-count="2" :caption="$t('registration.general')">
                <DxSimpleItem data-field="Year">
                    <dx-label :text="$t('registration.year')" />
                </DxSimpleItem>

                <DxSimpleItem data-field="Quarter">
                    <dx-label :text="$t('registration.quarter')" />
                </DxSimpleItem>
                </DxGroupItem>

                <DxGroupItem :caption="$t('registration.uimForecast')" :col-count="1">
                <DxSimpleItem name="UIMForecastGrid">
                    <template #default>
                    <DxDataGrid ref="UIMForecastRef" id="grid-container1" :show-borders="true"
                        :data-source="UIMForecastData" :row-alternation-enabled="true"
                        :hover-state-enabled="true" :selection="{ mode: 'multiple' }"
                        :column-hiding-enabled="true" key-expr="Id">
                        <DxColumn
                            data-field="Product_Id"
                            :caption="$t('registration.product')">
                        </DxColumn>
                        <DxColumn
                            data-field="Month"
                            :caption="$t('registration.month')">
                            <DxLookup
                                :data-source="MonthOptions"
                                value-expr="Id"
                                display-expr="Name"/>
                        </DxColumn>
                        <DxColumn data-field="UIMForecast" format="#,##0.##">
                        <DxFormItem
                        editor-type="dxNumberBox"
                        />
                        </DxColumn>
                        <DxColumnFixing :enabled="false" />
                        <DxGroupPanel :visible="true" />
                    </DxDataGrid>
                    </template>
                </DxSimpleItem>
                </DxGroupItem>
                <DxGroupItem :col-count="2" :caption="$t('registration.totalForecast')">
                <DxSimpleItem data-field="TotalForecast" :editor-options="{ readOnly: true, format: '#,##0.##' }">
                    <dx-label :text="$t('registration.totalForecast')" />
                </DxSimpleItem>
                </DxGroupItem>
                <br><br>
            </DxForm>
            </form>
        </div>
    </div>
</template>

<script>
import DxForm, {
    DxGroupItem,
    DxSimpleItem,
    DxButtonItem,
    DxLabel,
    // DxItemPanel,
    // DxItem,    
    DxRequiredRule,
    DxCompareRule,
    DxRangeRule,
    DxStringLengthRule,
    DxPatternRule,
    DxEmailRule,
    DxAsyncRule,
} from 'devextreme-vue/form'

import DxCheckBox from 'devextreme-vue/check-box';
import DxTooltip from 'devextreme-vue/tooltip';


import DxItemPanel from "devextreme-vue/tab-panel"
import DxAutocomplete from 'devextreme-vue/autocomplete'
import {
    DxDataGrid,
    DxColumn,
    DxEditing,
    DxToolbar,
    DxItem,
    DxFormItem,
    DxLookup,
    DxMasterDetail,
    DxColumnFixing,
    DxGroupPanel,
} from 'devextreme-vue/data-grid'

import DxRadioGroup from 'devextreme-vue/radio-group'

import DxButton from 'devextreme-vue/button'

import notify from 'devextreme/ui/notify'
import dateUtil from '@/helpers/dateUtil'

import { mapState, mapActions } from 'vuex'


export default {
    components: {
        DxGroupItem,
        DxSimpleItem,
        DxButtonItem,
        DxButton,
        DxRadioGroup,
        DxLabel,
        DxItemPanel,
        DxItem,
        DxDataGrid,
        DxColumn,
        DxEditing,
        DxFormItem,
        DxLookup,
        DxMasterDetail,
        DxToolbar,
        DxRequiredRule,
        DxCompareRule,
        DxPatternRule,
        DxRangeRule,
        DxEmailRule,
        DxStringLengthRule,

        DxCheckBox,
        DxTooltip,

        DxForm,
        DxAutocomplete,
        DxAsyncRule,
        DxColumnFixing,
        DxGroupPanel,

        notify,
    },

    data() {
        const incorporationData = {}
        const status = [
            {
                Id: 'Former',
                Name: 'Former'
            },
            {
                Id: 'Current',
                Name: 'Current'
            }
        ]

        return {
            CDP: {},
            ProductOptions: [],
            LastSelectedProduct: '',
            dataOperation: ['New', 'Update'],
            statusEditorOptions: status,
            UIMForecastData: [],
            AuditedAccountsData: [],
            CurrentCompanySecretariesData: [],
            DirectorsReportsData: [],
            AuditorsReportsData: [],
            OrderItemsData: [],
            AppointmentOfAuditorsData: [],
            ReasonOfTermination: [],
            accPeriod: '', extract: '', extractDate: '',
            dateOptions: { displayFormat: "dd-MM-yyyy" },
            selectedTabIndex: 0,
            isOrderVisible: true,
            formData: {},

            accountingPeriodOptions: {
                disabled: false,
                onValueChanged: e => {
                    //this.saveAccountingPeriodValue(e)
                },
            },
            extractOptions: {
                height: 70,
                onValueChanged: e => {
                    //this.saveExtractOfResolutionValue(e)
                },
            },
            incorporationData,
        }
    },

    props: {
      templateData: {
        type: Object,
        default: () => {},
      },
    },

    computed: {
        ...mapState({
            payerId: state => state?.user?.user?.data?.payer?.id
        }),
        NumberValidationRules() {
        return [
            {
            type: 'required',
            message: this.$t('registration.yearRequired')
            },
            {
            type: 'pattern',
            pattern: /^[0-9]+$/,
            message: this.$t('registration.yearRequired')
            }
        ]
        },
        MonthOptions() {
        return [
            {
            Id: "1",
            Name: this.$t('months.january')
            },
            {
            Id: "2",
            Name: this.$t('months.february')
            },
            {
            Id: "3",
            Name: this.$t('months.march')
            },
            {
            Id: "4",
            Name: this.$t('months.april')
            },
            {
            Id: "5",
            Name: this.$t('months.may')
            },
            {
            Id: "6",
            Name: this.$t('months.june')
            },
            {
            Id: "7",
            Name: this.$t('months.july')
            },
            {
            Id: "8",
            Name: this.$t('months.august')
            },
            {
            Id: "9",
            Name: this.$t('months.september')
            },
            {
            Id: "10",
            Name: this.$t('months.october')
            },
            {
            Id: "11",
            Name: this.$t('months.november')
            },
            {
            Id: "12",
            Name: this.$t('months.december')
            }
        ]
        },
        buttonOptions() {
            return {
            text: this.$t('orderAdd.save'),
            type: 'normal',
            useSubmitBehavior: true
            }
        },
        checkBoxOptions() {
        return {
            text: this.$t('registration.iAmForeigner'),
            onValueChanged: (e) => {
            this.passwordVisibility = e.component.option('value');
            this.formData.Foreigner = e.component.option('value');
            },
        }
        }
    },

    created() {

    },
    mounted() {
        this.bindFormData()
    },


    methods: {
        bindFormData() {
          this.formData = {
                Version: this.templateData?.data?.Version,
                Year: this.templateData?.data?.Year,
                Quarter: this.templateData?.data?.Quarter,
                TotalForecast: this.templateData?.data?.Total_Forecast
          }

          let data = this.templateData?.data?.Details
          this.UIMForecastData  = data.map((item, index) => {
            return {
                Id: index,
                No: index+1,
                Product_Id: item.revenue_Source.source_Name,
                Month: item.month,
                UIMForecast: Number(item.forecast)
            }
        })},

        handleShippingMethod(e) {
        },

        handleShipToLocation(e) {
            this.formData.Facility = e.value
            console.log(this.formData)
        },
        selectShippingMethod(method) {
        },
    }
}
</script>
<style scoped>
.shipping-option {
    display: flex;
    flex-direction: column;
    border: 1px solid #ccc;
    padding: 10px;
    border-radius: 5px;
    cursor: pointer;
    transition: all 0.2s ease-in-out;
    margin-bottom: 10px;
    /* Space between options */
}

.shipping-option.selected {
    border-color: #007bff;
    /* Highlight selected option */
    background-color: #eaf5ff;
    /* Light blue background for selected */
}

.checkbox-container {
    display: flex;
    align-items: center;
    margin-bottom: 5px;
}

.dx-checkbox {
    margin-right: 8px;
    /* Space between checkbox and label */
}

.shipping-label {
    font-weight: bold;
}

.delivery-info {
    font-size: 0.9em;
    color: #666;
    margin-left: 28px;
    /* Align with the text above, considering checkbox width */
}

.info-icon-standard {
    margin-left: 5px;
    cursor: help;
    color: #888;
}
</style>